module.exports = __webpack_public_path__ + "img/fullofcacti.09841cf4.png";